// 🔧 not_found_layout.js
// ✅ Purpose: Full-page shell for standalone 404 view
// ✅ Features:
// - Wraps the 404 page in full HTML structure
// - Loads required global styles
// - No navigation or extra layout elements

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../assets/css/slick.css";
import "../assets/css/style.css";
import Footer from "../components/footer";
import ResponsiveNav from "../components/ResponsiveNav";

const NotFoundLayout = ({ children }) => {
  return (
   <> 
   <ResponsiveNav />

   <div className="not-found-layout bg-light">
      {children}
    </div>

    <Footer />

   </>
  );
};

export default NotFoundLayout;
